module.exports = __webpack_public_path__ + "static/media/CriticalGreenPentagon.bb6fcedb.svg";